import { CheckCircle2, XCircle } from 'lucide-react';

interface TerminalStagesProps {
  won: { opportunities: number; value: string };
  lost: { opportunities: number; value: string };
  onWonClick: () => void;
  onLostClick: () => void;
}

export function TerminalStages({ won, lost, onWonClick, onLostClick }: TerminalStagesProps) {
  return (
    <div className="flex gap-3">
      {/* Closed Won */}
      <div
        onClick={onWonClick}
        className="flex-1 bg-gradient-to-br from-emerald-50 to-white border border-emerald-200 rounded-lg p-4 cursor-pointer hover:border-emerald-300 hover:shadow-sm transition-all group"
      >
        <div className="flex items-center gap-2 mb-2">
          <div className="w-7 h-7 rounded-lg bg-white flex items-center justify-center group-hover:bg-emerald-100 transition-colors">
            <CheckCircle2 className="w-4 h-4 text-emerald-600" />
          </div>
          <span className="text-xs text-gray-600">Closed Won</span>
        </div>
        <div>
          <p className="text-xl text-gray-900">{won.opportunities}</p>
          <p className="text-xs text-gray-400">{won.value}</p>
        </div>
      </div>

      {/* Closed Lost */}
      <div
        onClick={onLostClick}
        className="flex-1 bg-gradient-to-br from-gray-50 to-white border border-gray-200 rounded-lg p-4 cursor-pointer hover:border-gray-300 hover:shadow-sm transition-all group"
      >
        <div className="flex items-center gap-2 mb-2">
          <div className="w-7 h-7 rounded-lg bg-white flex items-center justify-center group-hover:bg-gray-200 transition-colors">
            <XCircle className="w-4 h-4 text-gray-500" />
          </div>
          <span className="text-xs text-gray-600">Closed Lost</span>
        </div>
        <div>
          <p className="text-xl text-gray-900">{lost.opportunities}</p>
          <p className="text-xs text-gray-400">{lost.value}</p>
        </div>
      </div>
    </div>
  );
}
